import React, { useEffect } from 'react';
import { css } from '@emotion/react';
import theme from '@styles/theme';
import { NavCloseBtn } from 'public/assets';
import { touchCtaEndingReport } from '@lib/eventManager';
import { useAppSelector } from '@/store/hooks';

interface IPlayerReportIframe {
  src: string;
  onClose: () => void;
}

const PlayerReportIframe = ({ src, onClose }: IPlayerReportIframe) => {
  const chapterData = useAppSelector((state) => state.chapter.playChapterInfo);

  useEffect(() => {
    window.addEventListener('message', handlePlayerReportMessage);

    return () => {
      window.removeEventListener('message', handlePlayerReportMessage);
    };
  }, []);

  const handlePlayerReportMessage = (event: MessageEvent) => {
    if (event.data.action === 'playerReportButton') {
      window.location.href = event.data.link;
      if (event.data.event === 'ctaButtonClick') {
        touchCtaEndingReport({
          storyId: chapterData?.playChapter.storyId,
          storyName: chapterData?.playChapter.story.name,
        });
      }
    }
  };

  return (
    <>
      <div css={container}>
        <div className="report-close">
          <NavCloseBtn
            onClick={onClose}
            width={24}
            height={24}
            fill={theme.colors.gray900}
          />
        </div>
        <iframe
          className="report-web"
          src={src}
          sandbox="allow-same-origin allow-scripts allow-modals"
        ></iframe>
      </div>
    </>
  );
};

const container = css`
  height: 100vh;
  width: 100%;
  z-index: 2;
  overflow: hidden;
  position: fixed;
  top: 0;

  .report-web {
    height: 100vh;
    width: 100%;
  }

  .report-close {
    position: absolute;
    right: 0.6rem;
    top: 0.6rem;
    cursor: pointer;
  }
`;

export default PlayerReportIframe;
